import { Component } from '@angular/core';
import { supportHelpMessages } from '@app/configs/app-message.config';

/** The "Need Help? Contact Support" text in the page header; one place so every screen reads the same. */
@Component({
  selector: 'app-support-help',
  standalone: true,
  templateUrl: './support-help.component.html',
  styleUrl: './support-help.component.scss'
})
export class SupportHelpComponent {
  readonly message = supportHelpMessages;
}
